import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { EventService } from "src/app/services/event.service";

@Component({
  selector: "fury-leads-table",
  templateUrl: "./leads-table.component.html",
  styleUrls: ["./leads-table.component.scss"],
})
export class LeadsTableComponent implements OnInit {
  @Input() displayedColumns: any[];
  @Input() dataSource: any[] = [];
  @Input() editorAccess: boolean;
  userId = '';
  constructor(public commonService: CommonService, private event: EventService, private router: Router, private activateRoute: ActivatedRoute,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
  }

  handleCheckout(element) {
    const checkoutData = {
      firstName: element?.firstName,
      lastName: element?.lastName,
      address: `${element?.address?.streetAddress}, ${element?.address?.city}, ${element?.address?.zip}, ${element?.address?.state}`,
      city: element?.address?.city,
      state: element?.stateName,
      zip: element?.address?.zip,
      email: element?.emailAddress?.toLowerCase(),
      phone: element?.mobileNumber,
      planTypeId: element?.propertyTypeId,
      planSizeId: element?.propertySizeId,
      leadId: element?.leadId,
      unitNumber: element?.address?.unitNumber,
      leadSource: element?.source,
      resultCode: element?.resultCode
    }
    this.event.checkoutAddress.next(checkoutData);

    this.apiService.routeToPage(`customer-dashboard/${this.userId}/checkout`);
  }
  navigteDetailsPage(data:any){
    this.apiService.routeToPage('/lead/lead-details/'+ data.leadId + '?type=customerInformation');
  }
}
